var WhoRewardedVisibility;
(function (WhoRewardedVisibility) {
    WhoRewardedVisibility["NO_REWARD"] = "NO_REWARD";
    WhoRewardedVisibility["LIMITED_OLD_REWARD"] = "LIMITED_OLD_REWARD";
    WhoRewardedVisibility["LIMITED_NEW_REWARD"] = "LIMITED_NEW_REWARD";
    WhoRewardedVisibility["LIMITED_CUSTOM_REWARD"] = "LIMITED_CUSTOM_REWARD";
    WhoRewardedVisibility["OLD_REWARD"] = "OLD_REWARD";
    WhoRewardedVisibility["NEW_REWARD"] = "NEW_REWARD";
    WhoRewardedVisibility["CUSTOM_REWARD"] = "CUSTOM_REWARD";
})(WhoRewardedVisibility || (WhoRewardedVisibility = {}));
export default WhoRewardedVisibility;
